import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { PuntPlayLog, RosterPlayer, TackleLog } from "../../../../types/LogTypes";
import { useLogger } from "../../../../contexts/LoggerContext";
import { PlayerSelection } from "../Components/PlayerSelection";

export const PuntTackleLog = () => {
  const [selectedPrimaryTackler, setSelectedPrimaryTackler] =
    useState<RosterPlayer | null>(null);
  const [selectedAssistedTackler, setSelectedAssistedTackler] = useState<
    RosterPlayer[] | []
  >([]);

  const [tackleLog, setTackleLog] = useState<TackleLog | null>(null);

  const [primaryJerseyNumber, setPrimaryJerseyNumber] = useState<string>("");
  const [assistedJerseyNumbers, setAssistedJerseyNumbers] = useState<string[]>(
    []
  );

  const { puntPlayers } = useDepthChart();
  const { currentPlayLog, setCurrentPlayLog, clearSelections } = useLogger();

  useEffect(() => {
    if (tackleLog && currentPlayLog) {
      setCurrentPlayLog({
        ...currentPlayLog,
        tackle: tackleLog
      } as PuntPlayLog);
    }
  }, [tackleLog]);

  useEffect(() => {
    if (selectedPrimaryTackler) {
      setTackleLog({
        ...tackleLog,
        primary_tackler_roster_player: selectedPrimaryTackler,
      });
    }
  }, [selectedPrimaryTackler]);
  
  useEffect(() => {
    if (selectedAssistedTackler) {
      setTackleLog({
        ...tackleLog,
        assisted_tacklers_roster_players: selectedAssistedTackler,
      });
    }
  }, [selectedAssistedTackler]);
  
  useEffect(() => {
    if (clearSelections) {
      setSelectedPrimaryTackler(null);
      setSelectedAssistedTackler([]);
      setPrimaryJerseyNumber("");
      setAssistedJerseyNumbers([]);
    }
  }, [clearSelections]);

  const handlePrimaryJerseyNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setPrimaryJerseyNumber(value);
      
    }
  };

  const handlePrimaryTacklerSelection = (player: RosterPlayer) => {
    setSelectedPrimaryTackler(player);
    setPrimaryJerseyNumber(player.jersey_number?.toString() || "");
    if (selectedPrimaryTackler) {
    setTackleLog({
      ...tackleLog,
      primary_tackler_roster_player: selectedPrimaryTackler,
    });
    };
  };

  const handleSecondaryJerseyNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setPrimaryJerseyNumber(value);
    }
  };

  const handleSecondaryTacklerSelection = (player: RosterPlayer) => {
    setSelectedAssistedTackler([...selectedAssistedTackler, player]);
    setAssistedJerseyNumbers([
      ...assistedJerseyNumbers,
      player.jersey_number?.toString() || "",
    ]);
    if (selectedAssistedTackler) {
      setTackleLog({
        ...tackleLog,
        assisted_tacklers_roster_players: selectedAssistedTackler,
      });
    }
  };

  

  return (
    <Box>
     <PlayerSelection
     title="Primary Tackler"
     players={puntPlayers}
     selectedPlayer={selectedPrimaryTackler}
     jerseyNumber={primaryJerseyNumber}
     maxDisplayedPlayers={4}
     handlePlayerSelection={handlePrimaryTacklerSelection}
     handleJerseyNumberChange={handlePrimaryJerseyNumberChange}
     />
     <PlayerSelection
     title="Assisted Tackler"
     players={puntPlayers}
     selectedPlayer={selectedAssistedTackler}
     jerseyNumber={assistedJerseyNumbers}
     maxDisplayedPlayers={4}
     handlePlayerSelection={handleSecondaryTacklerSelection}
     handleJerseyNumberChange={handleSecondaryJerseyNumberChange}
     />
    </Box>
  );
};
